/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Rating_JamesInputs */

const en_onboarding_rating_james = /** @type {(inputs: Onboarding_Rating_JamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantastic app for multitasking. I can now "read" while exercising or doing household chores.`)
};

const es_onboarding_rating_james = /** @type {(inputs: Onboarding_Rating_JamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App fantástica para hacer varias cosas a la vez. Ahora puedo "leer" mientras hago ejercicio o tareas del hogar.`)
};

/**
* | output |
* | --- |
* | "Fantastic app for multitasking. I can now \"read\" while exercising or doing household chores." |
*
* @param {Onboarding_Rating_JamesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_rating_james = /** @type {((inputs?: Onboarding_Rating_JamesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Rating_JamesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_rating_james(inputs)
	return en_onboarding_rating_james(inputs)
});